// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CameraCapture_overlay__WhTo2 {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #000;
  display: flex;
  flex-direction: column;
}

.CameraCapture_topbar__3GKx2 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  color: #fff;
}

.CameraCapture_closeBtn__bfjpb {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.CameraCapture_title__3K8lj {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}

.CameraCapture_count__oOoKT {
  min-width: 28px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #c9956a;
}

/* Live camera view — takes the remaining space */
.CameraCapture_videoWrap__EbadK {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
}

.CameraCapture_video__Rn2YY {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Tap-to-focus indicator — a yellow ring that pulses at the tapped point. */
.CameraCapture_focusRing__8bHR1 {
  position: absolute;
  width: 72px;
  height: 72px;
  border: 2px solid #ffd54a;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
  animation: CameraCapture_focusPulse__yN1Ix 0.9s ease-out forwards;
}

@keyframes CameraCapture_focusPulse__yN1Ix {
  0%   { opacity: 0; transform: translate(-50%, -50%) scale(1.4); }
  20%  { opacity: 1; }
  100% { opacity: 0; transform: translate(-50%, -50%) scale(1); }
}

.CameraCapture_error__FPiGO {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  color: #ff9999;
  font-size: 14px;
  line-height: 1.5;
}

/* Photos already taken */
.CameraCapture_strip__4rNwI {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  min-height: 84px;
  overflow-x: auto;
  background: #111;
}

.CameraCapture_stripHint__YK8Zg {
  color: #7a6e62;
  font-size: 12px;
  white-space: nowrap;
}

.CameraCapture_thumbWrap__1YDJK {
  position: relative;
  flex-shrink: 0;
}

.CameraCapture_thumb__amBX3 {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  border: 1px solid #2a2520;
}

.CameraCapture_thumbX__6anNi {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  padding: 0;
  cursor: pointer;
}

/* Shutter + upload bar */
.CameraCapture_controls__nSzuI {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px calc(16px + env(safe-area-inset-bottom, 0px));
  background: #000;
}

.CameraCapture_controlSide__MN1xH {
  flex: 1 1;
  display: flex;
  align-items: center;
}

.CameraCapture_controlSideRight__mv8Xx {
  justify-content: flex-end;
}

.CameraCapture_shutter__mgIfO {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.85);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
}

.CameraCapture_shutter__mgIfO:active .CameraCapture_shutterInner__Tqojn {
  transform: scale(0.88);
}

.CameraCapture_shutter__mgIfO:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.CameraCapture_shutterInner__Tqojn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.1s ease;
}

.CameraCapture_uploadBtn__9-Bur {
  background: #c9956a;
  color: #1a1815;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.CameraCapture_uploadBtn__9-Bur:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CameraCapture/CameraCapture.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,yCAAyC;EACzC,iEAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2CAA2C,EAAE;EAChE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: #000;\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  color: #fff;\n}\n\n.closeBtn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60%;\n}\n\n.count {\n  min-width: 28px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #c9956a;\n}\n\n/* Live camera view — takes the remaining space */\n.videoWrap {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: #0a0a0a;\n}\n\n.video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Tap-to-focus indicator — a yellow ring that pulses at the tapped point. */\n.focusRing {\n  position: absolute;\n  width: 72px;\n  height: 72px;\n  border: 2px solid #ffd54a;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);\n  animation: focusPulse 0.9s ease-out forwards;\n}\n\n@keyframes focusPulse {\n  0%   { opacity: 0; transform: translate(-50%, -50%) scale(1.4); }\n  20%  { opacity: 1; }\n  100% { opacity: 0; transform: translate(-50%, -50%) scale(1); }\n}\n\n.error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 24px;\n  color: #ff9999;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Photos already taken */\n.strip {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  min-height: 84px;\n  overflow-x: auto;\n  background: #111;\n}\n\n.stripHint {\n  color: #7a6e62;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.thumbWrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.thumb {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n  border: 1px solid #2a2520;\n}\n\n.thumbX {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0;\n  cursor: pointer;\n}\n\n/* Shutter + upload bar */\n.controls {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px calc(16px + env(safe-area-inset-bottom, 0px));\n  background: #000;\n}\n\n.controlSide {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.controlSideRight {\n  justify-content: flex-end;\n}\n\n.shutter {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: 4px solid rgba(255, 255, 255, 0.85);\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.shutter:active .shutterInner {\n  transform: scale(0.88);\n}\n\n.shutter:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.shutterInner {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.1s ease;\n}\n\n.uploadBtn {\n  background: #c9956a;\n  color: #1a1815;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.uploadBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CameraCapture_overlay__WhTo2`,
	"topbar": `CameraCapture_topbar__3GKx2`,
	"closeBtn": `CameraCapture_closeBtn__bfjpb`,
	"title": `CameraCapture_title__3K8lj`,
	"count": `CameraCapture_count__oOoKT`,
	"videoWrap": `CameraCapture_videoWrap__EbadK`,
	"video": `CameraCapture_video__Rn2YY`,
	"focusRing": `CameraCapture_focusRing__8bHR1`,
	"focusPulse": `CameraCapture_focusPulse__yN1Ix`,
	"error": `CameraCapture_error__FPiGO`,
	"strip": `CameraCapture_strip__4rNwI`,
	"stripHint": `CameraCapture_stripHint__YK8Zg`,
	"thumbWrap": `CameraCapture_thumbWrap__1YDJK`,
	"thumb": `CameraCapture_thumb__amBX3`,
	"thumbX": `CameraCapture_thumbX__6anNi`,
	"controls": `CameraCapture_controls__nSzuI`,
	"controlSide": `CameraCapture_controlSide__MN1xH`,
	"controlSideRight": `CameraCapture_controlSideRight__mv8Xx`,
	"shutter": `CameraCapture_shutter__mgIfO`,
	"shutterInner": `CameraCapture_shutterInner__Tqojn`,
	"uploadBtn": `CameraCapture_uploadBtn__9-Bur`
};
export default ___CSS_LOADER_EXPORT___;
